import { SearchAgency } from './types';
import { ReduxAction } from '../../redux/core';

export class ConciergeActionKey {
  public static FETCH_AGENCIES = `FETCH_AGENCIES`;
  public static SET_FETCHING_AGENCIES = `SET_FETCHING_AGENCIES`;
  public static SET_AGENCIES = `SET_AGENCIES`;
}

export interface FetchAgenciesAction extends ReduxAction<null> {}
export interface SetFetchingAgenciesAction extends ReduxAction<boolean> {}
export interface SetAgenciesAction extends ReduxAction<SearchAgency[]> {}

export type ConciergeAction = FetchAgenciesAction | SetFetchingAgenciesAction | SetAgenciesAction;

export function fetchAgencies(): FetchAgenciesAction {
  return {
    type: ConciergeActionKey.FETCH_AGENCIES,
    data: null,
  };
}

export function setFetchingAgencies(newValue: boolean): SetFetchingAgenciesAction {
  return {
    type: ConciergeActionKey.SET_FETCHING_AGENCIES,
    data: newValue,
  };
}

export function setAgencies(agencies: SearchAgency[]): SetAgenciesAction {
  return {
    type: ConciergeActionKey.SET_AGENCIES,
    data: agencies,
  };
}
